module.exports = "https://cdn.hellotech.com/client-assets/routers_mobile_73ac4b97abc4b27f7d091fdf84c6fab5.png";